import { render, staticRenderFns } from "./NflOdds.vue?vue&type=template&id=a6d498c0"
import script from "./NflOdds.vue?vue&type=script&lang=js"
export * from "./NflOdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports